import { render, staticRenderFns } from "./NumberToCurrencyNo.vue?vue&type=template&id=2b57061d&"
import script from "./NumberToCurrencyNo.vue?vue&type=script&lang=js&"
export * from "./NumberToCurrencyNo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports